import type { Node, NodeProps } from '@xyflow/react';
import { FolderIcon } from '@heroicons/react/24/outline';
import type { FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { NodeShell } from './NodeShell';

/** The root of the overview (no focus): the project itself. */
export function ProjectNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'project') return null;
  return (
    <NodeShell
      icon={FolderIcon}
      iconClassName="text-indigo-600 dark:text-indigo-400"
      compactClassName={KIND_PALETTE.project.compact}
      label={data.node.label}
      selected={data.selected}
      // Always the root, so it always carries the focus outline.
      focused
      className="w-50"
    >
      <div className="truncate text-sm font-medium">{data.node.label}</div>
      <div className="text-xs text-gray-500 dark:text-zinc-400">Whole project</div>
    </NodeShell>
  );
}
